<template>
    <div id="app" class="d-flex" style="width: 100vw; height: 100dvh;">
        <router-view />
        <!-- <div id="popup-promotion" style="display: none;">
            <div id="popup-promotion-backdrop" class="popup-promotion-backdrop d-flex align-items-center justify-content-center">
                <div class="popup-promotion-content">
                    <a href="#">
                        <img src="/promotion/1080x1080_HelloJuly_en.jpg"/>
                    </a>
                    <div id="popup-close-btn" class="popup-close-btn">
                        <a href="javascript:void(0);" @click="closePopup()">
                            <i class="fas fa-times-circle fa-2x text-danger"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
    // @ is an alias to /src
 
    import { mapState } from "vuex";

    export default {
        name: "app",
        components: {},
        watch: {
            user() {
                
            }, 
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
        },
        mounted() {
            $("#popup-promotion").fadeIn(200);
        },
        methods: {
            closePopup(){
                $("#popup-promotion").fadeOut(200);
            }
        }
    };
</script>
<style scoped>
body.popup-promotion-show {
  overflow: hidden;
}

.popup-promotion-backdrop {
  position: fixed;
  z-index: 200;
  background-color: rgba(0, 0, 0, 0.8);
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.popup-promotion-backdrop .popup-promotion-content {
  position: relative;
}

.popup-promotion-backdrop .popup-promotion-content .popup-close-btn {
  position: absolute;
  display: block;
  right: calc(-2em - 10px);
  top: 0;
  background-color: #fff;
  width: calc(2em + 4px);
  height: calc(2em + 4px);
  -webkit-border-radius: 200px;
  -moz-border-radius: 200px;
  border-radius: 200px;
  text-align: center;
  padding: 2px 2px 0 2px;
}


.popup-promotion-backdrop .popup-promotion-content img {
  width: 95vw;
  height: auto;
  max-height: 90vh;
  max-width: calc(90vw - 2 * (2em - 4px));
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

@media screen and (min-width: 769px) {
    .popup-promotion-backdrop .popup-promotion-content img {
        width: 40vw; 
    }
}
</style>
